import { type ReactNode } from 'react';
import { useProgressSummary } from '@/hooks/use-progress-summary';
import { usePricingRanges } from '@/hooks/use-pricing-ranges';
import { Fade } from '@/components/ui/fade';
import { useMinLoading } from '@/hooks/use-min-loading';
import { ProgressSkeleton } from './progress-skeleton';
import { ProgressBarsLoaded } from './progress-bars-loaded';

export function CreatorsProgressSection(): ReactNode {
  const { data, isLoading } = useProgressSummary();
  const { data: rangesData } = usePricingRanges();
  const showSkeleton = useMinLoading(isLoading);
  const state = showSkeleton || !data ? 'loading' : 'data';
  return (
    <Fade activeKey={state}>
      {state === 'loading' ? (
        <ProgressSkeleton />
      ) : (
        <ProgressBarsLoaded data={data!} ranges={rangesData?.ranges ?? []} />
      )}
    </Fade>
  );
}
